<template>
  <div class="submit-form  p-5 shadow p-3 m-5 bg-white rounded" >
     <form >
      <div v-if="submitted">
       <h4 >La tua comunicazione è stata registrata</h4>
       <p>controlla l'email per verificare la segnalazione appena trasmessa</p>
     </div>
    <div v-if="!submitted">
       <h4 class="mb-5">Modulo Segnalazione</h4>
      <div class="form-group mb-5">
        <!-- <label for="nominativo">è consigliato lasciare un nominativo</label> -->
        <input

          type="text"
          class="form-control"
          id="nominativo"
          placeholder="Nome Cognome"
          required
          v-model.trim="segnalazione.nominativo"
          name="nominativo"
        />
        <ul v-if="nomeerror.length" >
        <li v-for="error in nomeerror" :key="error" style="color:red">{{error}}</li></ul>
      </div>
            <div class="form-group mb-5">
        <!-- <label for="email">email sulla quale vuoi ricevere aggiornamenti riguardo la segnalazione</label> -->
        <input
        placeholder="Email"
          type="text"
          class="form-control"
          id="email"
          required
          v-model="segnalazione.email"
          name="email"
        />
        <ul v-if="mailerror.length">
          <li v-for="error in mailerror" :key="error"   style="color:red" >{{error}}</li>
          </ul>
      </div>
   <div class="form-group mb-5">
        <!-- <label for="description">Esponi la problematica che vuoi segnalare</label> -->
        <textarea
          class="form-control"
          id="contenuto"
          required
          placeholder="Esponi la problematica che vuoi segnalare"
          v-model="segnalazione.contenuto"
          name="contenuto"
          rows="4"
        />
        <ul v-if="contenutoerror.length"> <li v-for="error in contenutoerror" :key="error"  style="color:red" >{{error}}</li>
        </ul>
      </div>

      <div class="row">
        <captcha class="col" ref="captcha" @verify="saveSegnalazione(servizio.id )" />
 <span v-if="sending" class="sending col my-3" align="center"></span>
     <button id='btn' @click.prevent="executeCaptcha()"  class="botton-primary align-self-end m-10">Invia</button>
     </div>
        </div>
        </form>
  </div>
</template>

<script>
import SegnalazioniDataService from '@/service/SegnalazioniDataService.js'
import captcha from './captcha.vue'

export default {
  components: { captcha },
  name: 'form-segnalazione',
  props: {
    servizio: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      segnalazione: {
        id: null,
        nominativo: null,
        email: null,
        contenuto: null
      },
      submitted: false,
      nomeerror: [],
      mailerror: [],
      contenutoerror: [],
      sending: false
    }
  },
  methods: {
    saveSegnalazione (id) {
      if (
        !this.nomeerror.length &&
      !this.mailerror.length &&
      !this.contenutoerror.length) {
        var btn = document.getElementById('btn')
        btn.disabled = true
        btn.hidden = true
        this.sending = true

        var data = {
          nominativo: this.segnalazione.nominativo, // ? this.segnalazione.nominativo : 'Anonimo',
          email: this.segnalazione.email,
          contenuto: this.segnalazione.contenuto
        }

        SegnalazioniDataService.postSegnalazione(id, data)
          .then(response => {
            this.segnalazione.id = response.data.id
            console.log(response.data)
            this.submitted = true
          })
          .catch(e => {
            console.log(e)
            var btn = document.getElementById('btn')
            btn.disabled = false
            btn.hidden = false
            this.sending = false
          })
      }
    },
    validate () {
      this.nomeerror = []
      this.mailerror = []
      this.contenutoerror = []
      if (!this.segnalazione.nominativo) {
        this.nomeerror.push('Inserisci un nominativo')
      }
      if (!this.segnalazione.email) {
        this.mailerror.push('Inserisci email')
      } else if (!this.validEmail(this.segnalazione.email)) {
        this.mailerror.push('email non valida')
      }
      if (!this.segnalazione.contenuto) {
        this.contenutoerror.push('Inserisci contenuto')
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    executeCaptcha () {
      this.validate()
      this.$refs.captcha.exeCaptcha()
    }

  },
  watch: {
    servizio: function (NewServizio, OldServizio) {
      console.log('OLD -->', OldServizio)
      console.log('NEW -->', NewServizio)
    }
  }
}
</script>
<style>
.submit-form {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
</style>
